import { Camera, Mic, Sun, Aperture, Film, Headphones } from "lucide-react";

const gear = [
  { icon: Camera, label: "Blackmagic URSA · Pocket 6K" },
  { icon: Aperture, label: "Sigma Art · Cine-optik" },
  { icon: Sun, label: "Aputure · Nanlite ljus" },
  { icon: Mic, label: "Sennheiser · Rode mygg & boom" },
  { icon: Headphones, label: "Pro Tools · ljudmix" },
  { icon: Film, label: "DaVinci Resolve · färgläggning" },
];


export function GearStrip() {
  const loop = [...gear, ...gear];
  return (
    <section
      aria-label="Utrustning"
      className="relative overflow-hidden border-y border-white/10 py-6"
      style={{
        WebkitMaskImage:
          "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
        maskImage:
          "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
      }}
    >
      <div className="flex w-max items-center gap-12 animate-[gearMarquee_50s_linear_infinite] motion-reduce:animate-none">
        {loop.map((g, i) => {
          const Icon = g.icon;
          return (
            <div
              key={i}
              className="flex shrink-0 items-center gap-3 text-sm font-medium uppercase tracking-[0.16em] text-foreground/55"
            >
              <Icon className="h-4 w-4 text-butter" />
              <span>{g.label}</span>
            </div>
          );
        })}
      </div>
      <style>{`
        @keyframes gearMarquee {
          from { transform: translate3d(0,0,0); }
          to   { transform: translate3d(-50%,0,0); }
        }
      `}</style>
    </section>
  );
}
